// extracted by mini-css-extract-plugin
module.exports = {"M":"footer_M__31WIJ","Footer":"footer_Footer__2Vhlm"};